import React, { useEffect, useState } from 'react';
import { Grid, Typography, TextField, Snackbar, CircularProgress, Select, MenuItem, FormControl, Box } from '@mui/material'
import PropTypes from 'prop-types';
import { connect, useDispatch } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
// import Swal from "sweetalert2";
import appConfig from "../config/appConfig";
import * as menuActions from '../store/actions/breadcrumb';
import '../style/common.css';
import * as Styled from '../components/styled-components/Styled-Components';
import RadioButtonGroup from '../components/RadioButtonGroup';
import BusinessUnitLocationMapping from '../pages/SignIn/BusinessUnitLocationMapping';
import { useForm, Controller } from 'react-hook-form';
import * as userActions from '../store/actions/userManagement';
import { useLogout } from '../components/Utils';
import { useTranslation } from 'react-i18next';

const ErrorStyle = {
    color: "red",
    display: 'flex',
    marginTop: '5px'
}
const textboxCss = {
    borderRadius: "3px",
    outline: "none",
    '&.MuiFormControl-root': {
        margin: "0"
    },
    '&.MuiTextField-root': {
        backgroundColor: '#fff'
    },
    '& .MuiInputBase-input': {
        backgroundColor: '#fff',
        fontSize: 16,
        fontFamily: appConfig.fontfamily,
        padding: "10px 14px",
        borderRadius: "3px",
        outline: "none",
        height: "35px",
        boxSizing: 'border-box',
        border: `1px solid ${appConfig.colors.secondaryBlue}`,
    },
    '& .MuiOutlinedInput-root': {
        padding: '0',
    }
};


const Profile = ({setBreadcrumb,getAdminDetails, adminDetails, getBUnitFilterDetails, bunitFilterList, updateNewUserMgt, updatedUserMgtData, getRolesLov, rolesLov}) => {
    const langs = {
        "en": "English",
        "gr": "German",
        "sp_mex": "Spanish (Mexico)",
        "sp_sp": "Spanish (Spain)",
        "sl": "Slovakia",
        "ch": "Chinese",
        "pr": "Portuguese"
      };
    
    const { i18n } = useTranslation('common');
    const { t } = useTranslation('common');
    const dispatch = useDispatch()

    const params = useLocation();
    const navigate = useNavigate();
    const { register, handleSubmit, formState: { errors }, control, setValue } = useForm();
    const [isLoading, setIsLoading] = useState(false);
    const [roles, setRoles] = useState();
    const [locationError, setLocationErr] = useState(false);
    const [selectedItems, setSelectedItems] = useState([]);
    const [defaultSelectedId, setDefaultSelectedIds] = useState([]);
    const [userID, setUserID] = useState();
    const [businessOption, setBusinessOption] = useState([])

    const [isAdminUser, setIsAdminUser] = useState("");
    const [apiError, setAPIError] = useState("")
    const [successMessage, setSuccessMessage] = useState("")
    const [open, setOpen] = useState(false);

    const [userDetails, setUserDetals] = useState({})
    const onLogout = useLogout();
    const [language, setLanguage] = useState("en"); // Default language

    useEffect(() => {
        const storedLanguage = sessionStorage.getItem("language") || userDetails?.langPreference || "en";
        setLanguage(storedLanguage);
        i18n.changeLanguage(storedLanguage);
      }, [i18n]);
    
      const handleChange = (e) => {
        const newValue = e.target.value;
        // i18n.changeLanguage(newValue);
        setLanguage(newValue);
        // sessionStorage.setItem("language", newValue); // Save to session storage
      };

    useEffect(()=>{
        if(rolesLov && rolesLov.status === 200 ){
            setRoles(rolesLov.data)
        } else if(rolesLov && rolesLov.status === 401 ){
            onLogout();
        }
    },[rolesLov])

    useEffect(() => {
        getAdminDetails();
        getBUnitFilterDetails();
        getRolesLov();
        setBreadcrumb(t("My Profile"));
      }, []);
      useEffect(() => {
        if(adminDetails && adminDetails.status === 200) {
            const userInfo = JSON.parse(window.localStorage.getItem("userInfo"));

            setUserDetals(adminDetails?.data)
            const data = adminDetails?.data
            setValue('email', data.email)
            setValue('isAdminUser',  data?.roleId === 201 ? "Yes" : "No")
            setValue('isActive',  data?.isActive === true ? "Yes" : "No")
            setUserID(userInfo?.userId)
            setIsAdminUser(data?.roleId === 201 ? "Yes" : 'No')
            setLanguage(data?.langPreference || "en")
            setBusinessOption(data?.locationData?.map(item => item.businessUnitName))
            // setSelectedItems(data)
            let locationData = {
            }
            data && data.locationData?.forEach(input => {
                locationData[input.businessUnitName] = input?.businessLocation ? input?.businessLocation : input?.businessUnitLocations || []
            });
            const allLocations = Object.values(locationData).flat();
            const allItemIds = allLocations.map((item) => item.businessLocationId);
            setSelectedItems(allItemIds ? allItemIds : [])
            setDefaultSelectedIds(allItemIds ? allItemIds : [])
        }
        else if (adminDetails && adminDetails.status === 403){
            // setIsLoading(false);
            setAPIError(adminDetails.message)
        }
        else if (adminDetails && adminDetails.status === 401){
            onLogout();
        }
    }, [adminDetails]);
      const handleFormSubmit = (data) => {
        if(isAdminUser === 'No' && selectedItems && selectedItems.length === 0){
            setLocationErr(true);
            return
        }
        setLocationErr(false)
        const errorKeys = Object.keys(errors)
        if(errorKeys.length === 0){
            sendFormValues(data);
        }
    }
    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
          return;
        }
        setOpen(false);
      };
      

    const sendFormValues = (formData) => {
        let roleObject = [];
        setAPIError("");
        // setIsLoading(true);
        const deletedElements = defaultSelectedId.filter(item => !selectedItems.includes(item));
        const newElements = selectedItems.filter(item => !defaultSelectedId.includes(item));
        const data = {
                "userId": userID,
                "firstName": userDetails?.firstName,
                "middleName": userDetails?.middleName,
                "lastName": userDetails?.lastName,
                "roleId": userDetails?.roleId,
                "isActive": true,
                "langPreference": language,
                "newLocationIds": newElements || [] ,
                "deleteLocationIds": deletedElements || [],
                "lastModifiedBy": "Build Script",
                "isUpdateFromProfile": true
              }
              window.sessionStorage.setItem("language", language)
             updateNewUserMgt(data)
    }
    
    useEffect(() => {
        if(updatedUserMgtData && updatedUserMgtData.status === 200) {
            setIsLoading(false);
            navigate('/home');
            dispatch({
                type: "RESET_PROFILE",
                payload: null
            })
        }
        else if (updatedUserMgtData && updatedUserMgtData.status === 403){
            setIsLoading(false);
            setSuccessMessage(updatedUserMgtData.message)
            setOpen(true);
        }
        else if (updatedUserMgtData && updatedUserMgtData.status === 401){
            setIsLoading(false);
            onLogout();
        }
    }, [updatedUserMgtData]);
       
    return <div>
            <Grid container spacing={2}>
                <Grid item xs={6} sm={6} xl={6} lg={6} md={6}>
                    <h1 style={{ margin: 0, fontSize: "21px" }}><b>{t("My Profile")}</b></h1>
                </Grid>
            </Grid>
          
            <hr className='blue-border' style={{marginBottom: 35}}/>
            <form onSubmit={handleSubmit(handleFormSubmit)}>
                {/* <Grid container spacing={2} className='mb-20'>
                    <Grid item md={6.1} xl={6.1} lg={6.1} sm={12} xs={12}>
                        <div >
                            <Typography component="p" sx={{ mb: 1, color: appConfig.colors.black, textTransform: 'capitalize' }} className='xxs-normal'>{t("Admin User")}  <span style={{color:"red"}}>{" *"}</span></Typography>
                            <Controller
                                name="isAdminUser"
                                control={control}
                                rules={{ required: 'Please select an option' }} // Add the required rule
                                render={({ field }) => (
                                    <>
                                    <RadioButtonGroup
                                        key={field.value}
                                        className={['create-using-account-radio',userDetails?.roleId === 201 ? "yes" : "no"].join(' ')}
                                        value={userDetails?.roleId === 201 ? 'Yes' : "No"}
                                        labels={['Yes', 'No']}
                                        handleChange={(value) => field.onChange(value)}
                                    />
                                    {errors.isAdminUser && <span style={ErrorStyle}>{errors.isAdminUser.message}</span>}
                                    </>
                                )}
                                />
                            </div>
                    </Grid>
                </Grid> */}
                <Grid container spacing={2} className='mb-20'>
                    <Grid item md={6.1} xl={6.1} lg={6.1} sm={12} xs={12}>
                        <div >
                            <Typography component="p" sx={{ mb: 1, color: appConfig.colors.black }} className='xxs-normal'>{t("Email ID")}  <span style={{color:"red"}}>{" *"}</span></Typography>
                            <TextField
                                {...register('email', { required: true, pattern: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i})}
                                margin="normal"
                                id="email"
                                sx={textboxCss}
                                value={userDetails?.email}
                                disabled
                                className='input-box'
                                fullWidth
                                inputProps={{ "aria-label": "email" }}
                            />
                        </div>
                        {errors?.email?.type === "required" && <span style={ErrorStyle}>{t("Please enter email id")}</span>}
                        {errors?.email?.type === "pattern" && (<span style={ErrorStyle}>{t("Please enter valid email id")}</span>)}
                    </Grid>
                </Grid>
                <Grid container spacing={2} className='mb-20'>
                    <Grid item md={6.1} xl={6.1} lg={6.1} sm={12} xs={12}>
                        <Typography component="p" sx={{ mb: 1, color: appConfig.colors.black }} className='xxs-normal'>{t("Language")}  <span style={{color:"red"}}>{" *"}</span></Typography>
                        <FormControl style={{width: "100%"}}>
                            <Select
                                labelId="demo-simple-select-label"
                                // id="language-select"
                                sx={textboxCss}
                                label="Language"
                                value={language}
                                onChange={handleChange}
                                renderValue={(value) => (
                                <Box sx={{ display: "flex", marginTop: '-5px' }}>
                                    {/* <img src={languageicon} alt="language" /> */}
                                    {langs[value]}
                                </Box>
                                )}
                            >
                                {Object.keys(langs).map((key) => (
                                <MenuItem key={key} value={key} style={{fontSize: 14}}>
                                    <Box >
                                    {/* <img src={languageicon} alt="language" /> */}
                                    {langs[key]}
                                    </Box>
                                </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </Grid>
                </Grid>
                {/* <Grid container spacing={2} className='mb-20'>
                    <Grid item md={4.1} xl={4.1} lg={4.1} sm={12} xs={12}>
                        <div >
                            <Typography component="p" sx={{ mb: 1, color: appConfig.colors.black, textTransform: 'capitalize' }} className='xxs-normal'>{t("First Name")}  <span style={{color:"red"}}>{" *"}</span></Typography>
                            <TextField
                                {...register('firstname', { required: true, pattern: /^[A-Za-z0-9 ]+$/})}
                                margin="normal"
                                id="firstname"
                                sx={textboxCss}
                                value={userDetails?.firstName}
                                disabled
                                className='input-box'
                                fullWidth
                                inputProps={{ "aria-label": "first name" }}
                            />
                        </div>
                        {errors?.firstname?.type === "required" && <span style={ErrorStyle}>Please enter first name.</span>}
                        {errors?.firstname?.type === "pattern" && (<span style={ErrorStyle}>Special characters not allowed.</span>)}
                    </Grid>
                    <Grid item md={2} xl={2} lg={2} sm={12} xs={12}>
                        <div >
                            <Typography component="p" sx={{ mb: 1, color: appConfig.colors.black, textTransform: 'capitalize' }} className='xxs-normal'>{t("Middle Initial")}</Typography>
                            <TextField
                                {...register('miiddlename', { required: false, pattern: /^[A-Za-z0-9 ]+$/})}
                                margin="normal"
                                id="miiddlename"
                                sx={textboxCss}
                                value={userDetails?.middleName}
                                disabled
                                className='input-box'
                                fullWidth
                                inputProps={{ "aria-label": "middle name" }}
                            />
                        </div>
                    </Grid>
                </Grid> */}
                {/* <Grid container spacing={2} className='mb-20'>
                    <Grid item md={6.1} xl={6.1} lg={6.1} sm={12} xs={12}>
                        <div >
                            <Typography component="p" sx={{ mb: 1, color: appConfig.colors.black, textTransform: 'capitalize' }} className='xxs-normal'>{t("Last Name")} <span style={{color:"red"}}>{" *"}</span></Typography>
                            <TextField
                                {...register('lastname', { required: true, pattern: /^[A-Za-z0-9 ]+$/})}
                                margin="normal"
                                id="lastname"
                                sx={textboxCss}
                                value={userDetails?.lastName}
                                disabled
                                className='input-box'
                                fullWidth
                                inputProps={{ "aria-label": "last name" }}
                            />
                        </div>
                        {errors?.lastname?.type === "required" && <span style={ErrorStyle}>Please enter last name.</span>}
                        {errors?.lastname?.type === "pattern" && (<span style={ErrorStyle}>Special characters not allowed.</span>)}
                    </Grid>
                </Grid> */}
                <Grid container spacing={2} className='mb-20'>
                    <Grid item md={6.1} xl={6.1} lg={6.1} sm={12} xs={12}>
                        <Typography component="p" sx={{ mb: 1, color: appConfig.colors.black }} className='xxs-normal'>{t("Select your Locations")}  <span style={{color:"red"}}>{" *"}</span></Typography>
                        <BusinessUnitLocationMapping dataObj={isAdminUser} businessOption={businessOption} selectedItems={selectedItems} setSelectedItems={setSelectedItems} bunitFilterList={bunitFilterList} isBUser={userDetails?.roleId === 202} />
                    </Grid>
                </Grid>
                <Snackbar
                    open={open}
                    anchorOrigin={{ vertical: "top", horizontal: "right" }}
                    autoHideDuration={1000}
                    onClose={handleClose}
                    message={successMessage}
                />

                { locationError && <span style={ErrorStyle}>{t("Please choose the options")}</span>}
                {/* {userDetails?.roleId !== 201 && ( */}
                    <Grid container spacing={2}>
                        <Grid item  xs={12} sm={6.05} xl={3.05} lg={3.05} md={3.05}>
                                <Styled.PrimaryButton
                                    type='submit'
                                    variant="contained"
                                    sx={{ mt: 3, fontFamily: appConfig.fontfamily, textTransform: 'capitalize', width: "100%", height: "51px" }}
                                    color="primary"
                                    className="xxs-bold"
                                    disabled={isLoading}
                                >
                                    {isLoading ? (<><CircularProgress className='progress-color' /><span style={{color:'#fff'}}>{t("Saving...")}</span></>) : <span>{t("Save")}</span>}
                                </Styled.PrimaryButton>
                            </Grid>
                            <Grid item xs={12} sm={6.05} xl={3.05} lg={3.05} md={3.05}>
                                <Styled.CancelButton
                                    variant="outlined"
                                    sx={{ mt: 3, fontFamily: appConfig.fontfamily, textTransform: 'capitalize', width: "100%", height: "51px" }}
                                    color="primary"
                                    className="xxs-bold"
                                    onClick={() => navigate('/home')}
                                >
                                    {t("Cancel")}
                                </Styled.CancelButton>
                            </Grid>
                            
                        </Grid>
                    {/* // )} */}
                    {/* {userDetails?.roleId === 201 && (
                        <Grid container spacing={2}>
                            <Grid item xs={12} sm={6.1} xl={6.1} lg={6.1} md={6.1}>
                                <Styled.CancelButton
                                    variant="outlined"
                                    sx={{ mt: 3, fontFamily: appConfig.fontfamily, textTransform: 'capitalize', width: "100%", height: "51px" }}
                                    color="primary"
                                    className="xxs-bold"
                                    onClick={() => navigate('/home')}
                                >
                                    {t("Cancel")}
                                </Styled.CancelButton>
                            </Grid>
                        </Grid>
                    )} */}

            </form>
    </div >
}

Profile.propTypes = {
    setBreadcrumb: PropTypes.func.isRequired,
    updateNewUserMgt: PropTypes.func.isRequired,
    adminDetails: PropTypes.func.isRequired,
}


const mapDispatchToProps = (dispatch) => {
    return {
        setBreadcrumb: (menu) => dispatch(menuActions.setSubmenu(menu)),
        getBUnitFilterDetails: () => dispatch(userActions.getBUnitFilterDetails()),
        getAdminDetails: () => dispatch(userActions.getAdminDetails()),
        updateNewUserMgt: (data) => dispatch(userActions.updateNewUserMgt(data)),
        getRolesLov: () => dispatch(userActions.getRolesLov()),
    };
}
const mapStateToProps = (state) => ({ 
    updatedUserMgtData: state.userReducer.updatedUserMgtData,
    adminDetails: state.userReducer.adminDetails,
    rolesLov: state.userReducer.rolesLov,
    bunitFilterList: state.userReducer.bunitFilterList,
 })


export default connect(mapStateToProps, mapDispatchToProps)(Profile);